export const ROLE = {
  ALLOCATOR: 'Allocator',
  CFN: 'CFN',
  CONTEXT: 'Context',
  MANAGER: 'Manager',
  SERVICE_PROVIDER: 'Service Provider',
}
